import React from 'react'
import {
    FormattedMessage,
    AppId
} from 'base-app'
// export const API_URL = 'https://apidev.inon.vn'

export const API_URL = 'https://api.inon.vn'


export const SUCCESS_CODE = 200

export const VEHICLE_STATUS_NEW = 'NEW'

export const VEHICLE_STATUS_OLD = 'OLD'

export const VEHICLE_STATUS_ROLLOVER = 'ROLLOVER'

export const ID_TYPE_CMND = 'CMND'

export const ID_TYPE_CCCD = 'CCCD'

export const ID_TYPE_HOCHIEU = 'HOCHIEU'

export const ID_TYPE_MST = 'MST'

export const CUSTOMER_ORG = 'ORG'

export const CUSTOMER_INV = 'INV'

export const CUSTOMER_BANK = 'BANK'

export const PAY_FUND_TRANSFER = 'FUND_TRANSFER'

export const PAY_FUND_VISA = 'VISA_MASTER'

export const PAY_FUND_ATM = 'ATM'

export const PAY_FUND_QR = 'QR_CODE'

export const PAY_FUND_GPAY = 'GPAY'

export const ACTION_APPROVED = 'APPROVED'

export const ACTION_DECLINED = 'REJECT'

export var InsuStatus = {
    SUCCESS: 'FINISH',
    FAIL: 'FAIL',
    NOT_COMPLETE: 'NOT_COMPLETE',
    APPROVAL: 'APPROVAL',
    PENDING: 'PENDING',
    REJECT: 'REJECT'
};
